var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    { attrs: { widget: _vm.widget } },
    [
      _c("div", { staticClass: "reporting-call-logs-header" }, [
        _c("h2", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "RTT_DASHBOARD_FILTER_HEADER",
              expression: "'RTT_DASHBOARD_FILTER_HEADER'"
            }
          ],
          staticClass: "reporting-call-logs-header__title"
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "r-form rtb-dashboard display-flex flex--wrap p-b-30" },
        [
          _c("SearchableDropdown", {
            staticClass: "rtb-export-timezone m-r-15 m-b-15",
            attrs: {
              rules: "required",
              config: _vm.timeZoneOptions,
              clearable: false,
              disabled: ""
            },
            model: {
              value: _vm.timeZoneId,
              callback: function($$v) {
                _vm.timeZoneId = $$v
              },
              expression: "timeZoneId"
            }
          }),
          _vm._v(" "),
          _c("DateRangePicker", {
            staticClass: "m-b-15",
            attrs: {
              "date-range-button-class":
                "btn daterangepicker-btn--form m-r-15 m-b-15",
              "date-range": _vm.timeRange,
              options: _vm.dateRangeConfig,
              "time-zone-id": _vm.translatedTimeZoneId
            },
            on: { onDateRangeChange: _vm.onDateRangeChange }
          }),
          _vm._v(" "),
          _c(
            "PrimaryButton",
            {
              staticClass: "p-l-15 m-b-15",
              class: _vm.isSearching ? "p-r-35" : "p-r-15",
              attrs: { "show-loader-on-form": _vm.isSearching, type: "button" },
              on: {
                click: function($event) {
                  return _vm.onFilter(_vm.timeRange)
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-filter",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("RTT_DASHBOARD_FILTER")) + "\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("RingTreeTargetPings", {
        staticClass: "rtb-stats__widget--alt m-b-20",
        attrs: {
          "ping-data": _vm.rttPingData || [],
          "date-range": _vm.currentFilteredTimeRangeDetails,
          "is-loading": _vm.isSearching
        }
      }),
      _vm._v(" "),
      _c("RingTreeTargetErrors", {
        staticClass: "rtb-stats__widget--alt m-b-20",
        attrs: {
          "error-data": _vm.rttErrorData || [],
          "date-range": _vm.currentFilteredTimeRangeDetails,
          "is-loading": _vm.isSearching
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }